import CommonInterface from './CommonInterface';

export default class BaseUtils extends CommonInterface {
  constructor() {
    super();
  }
}
